import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import "../css/TextToPayInstructionsModal.css";
import InstructionSection from "./InstructionSection";
import Images from "../assets/images/Images";

const TextToPayInstructionsModal = (props) => {
  // needed props: setShowTextToPayInstructionsModal, showModal
  const [loadSpinner, setLoadSpinner] = useState(false);

  // Closes Opt In/Out Modal
  const closeModal = () => {
    props.setShowTextToPayInstructionsModal(false);
  };

  return (
    <>
      <Modal
        dialogClassName="my-modal"
        show={props.showModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable={true}
        onHide={closeModal}
        centered
      >
        <div className={"mainContainer"}>
          <Modal.Header className={'modalHeaderContainer'}>
            <div className={"headerContainer"}>
              <div className={"titleText"}><span>Text-to-Pay</span> <span>Enrollment Instructions</span></div>
              <img style={{marginLeft: '20px', width: "50px"}}src={Images.infoIcon}/>
              <div 
              style={{
                marginLeft: 'auto',
                cursor: 'pointer',
                fontSize: '30px',
                fontWeight: 'bold',
                position: 'absolute',
                top: '0px',
                right: '30px',
                color: '#818282'
              }}
              onClick={closeModal}
            >
              &times;
            </div>
            </div>
          </Modal.Header>
          <div className={"bodyContainer"}>
            <div className={"bodyIntro"}>
              <span>
                Let’s get you enrolled in Text-to-Pay! Once enrolled, you can
                pay using your checking, savings, credit or debit card. A
                convenience fee of $5.99 applies.*
              </span>
              &nbsp;
              <span>
                Note: Please enroll at least 6 days prior to your bill due date
                to ensure you receive a text to make the payment.
              </span>
            </div>
            <InstructionSection />
            <div className={"bodyIntro"}>
              &nbsp;
              <span>Congratulations! You are now enrolled in Text-to-Pay.</span>
              &nbsp;
              <span>
                You will receive a text 5 days prior to your bill due date and
                must reply "PAY" to make your text-to-pay payment with your
                defaulted payment method. A convenience fee of $5.99 will be
                applied.*
              </span>
            </div>
          </div>
          <div className={"footerContainer"}></div>
        </div>
        <Modal.Footer>
          <div className={"modalFooter"}>
            <div>
              *The third party convenience fee, charged by One Inc, will be added
              to your payment. For more information about One Inc, visit
              <a href={"https://www.oneinc.com/"} target="_blank" rel="noopener noreferrer" style={{marginLeft: '5px', textDecoration: 'underline'}}>oneinc.com</a>.
            </div>
            <div className={"closeButton"} onClick={closeModal}>Close</div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default TextToPayInstructionsModal;
